import CommonUtils from '@/common-utils';
import routes from './routes.common';

const result = (routes as any).concat([
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/biz-kr/login/Login.vue')
  },
]);

result[0].children = result[0].children.concat([
  {
    path: '/member/sign-up/1', // 회원가입1
    name: 'SignUp1',
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/member/SignUp1.vue'),
  },
  {
    path: '/member/sign-up/2', // 회원가입2
    name: 'SignUp2',
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/member/SignUp2.vue'),
  },
  {
    path: '/member/sign-up/3', // 회원가입3
    name: 'SignUp3',
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/member/SignUp3.vue'),
  },
  {
    path: '/member/sign-up/4', // 회원가입4
    name: 'SignUp4',
    props: true,
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/member/SignUp4.vue'),
  },  
  {
    path: '/login/find-password/confirm', // 비밀번호 찾기 아이디 확인
    name: 'FindPasswordConfirm',
    props: true,
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/login/FindPasswordConfirm.vue'),
  },
  {
    path: '/login/find-password/retype', // 비밀번호 찾기 재설정
    name: 'FindPasswordRetype',
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/login/FindPasswordRetype.vue'),
  },
  {
    path: '/mypage/member-info', // 회원 정보
    name: 'MemberInfo',
    meta: { auth: true },
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/mypage/MemberInfo.vue'),
  },  
]);


export default result;